import { Box, Tooltip } from '@mantine/core'

import * as classes from '@/styles/ContentModuleFormScreen.css'

export function AnalyzingBadge({ progress }: { progress?: { current: number; total: number } | null }) {
  const pct = progress && progress.total > 0 ? Math.round((progress.current / progress.total) * 100) : 0
  const tooltipLabel = progress && progress.total > 0 ? `${pct}% progress` : 'Analyzing…'

  return (
    <Tooltip label={tooltipLabel} withArrow position="top">
      <Box className={classes.analyzingBadge}>
        <span className={classes.analyzingBadgeProgress} style={{ width: `${pct}%` }} />
        <span className={classes.analyzingBadgeLabel}>
          Analyzing
          <span className={classes.analyzingDotsWrapper}>
            <span className={classes.analyzingDotsAfter} />
          </span>
        </span>
      </Box>
    </Tooltip>
  )
}
